export default "__VITE_ASSET__DSdhUfU___"